import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { ColorSchemeCSSVariable } from './use-color-scheme';

export function Cap() {
  const { logo, headerTitle } = useSettings();
  return (
    <Container>{!!logo && <Logo alt={headerTitle} src={logo.url} />}</Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
  background:
    linear-gradient(
      0deg,
      var(${ColorSchemeCSSVariable.CapBackground}),
      var(${ColorSchemeCSSVariable.CapBackground}) 100%
    ),
    linear-gradient(69.4deg, #fafafa 28.79%, #e7e7e7 105.74%);
`;

const Logo = styled.img`
  display: block;
  width: 48px;
  height: 48px;
  object-fit: contain;
`;
